/**
 * Envio ERC-20 igual ao completao.jsx: só preenche os dados da tela.
 * Nenhum tratamento extra — BrowserProvider(provider) → getSigner → Contract → decimals → transfer.
 * Usado para WalletConnect e MetaMask/Phantom; chainId opcional para MetaMask.
 */

import { Contract, BrowserProvider, parseUnits } from 'ethers';
import { ERC20_TRANSFER_ABI } from '@/config/stablecoinContracts';

/**
 * Faz o envio exatamente como no completao.jsx (handleSubmit).
 * @param {import('ethers').Eip1193Provider} provider - Provider bruto (MetaMask, WalletConnect, Phantom)
 * @param {string} tokenAddress - Endereço do contrato do token (ex.: USDC)
 * @param {string} recipient - Endereço do destinatário
 * @param {string} amount - Valor em string como na tela (ex.: "1" ou "1.00")
 * @param {string|number|undefined|null} [chainId] - Opcional; quando informado (ex.: MetaMask), usa BrowserProvider(provider, chainId)
 */
export async function sendStablecoinTransferCompletao(provider, tokenAddress, recipient, amount, chainId = undefined) {
  const chainIdDecimal = chainId != null ? parseInt(String(chainId), 16) : undefined;
  const ethersProvider = chainIdDecimal != null
    ? new BrowserProvider(provider, chainIdDecimal)
    : new BrowserProvider(provider);
  const signer = await ethersProvider.getSigner();
  const contract = new Contract(tokenAddress, ERC20_TRANSFER_ABI, signer);

  let decimals = 6;
  try {
    decimals = Number(await contract.decimals());
  } catch {
    // mantém 6
  }

  const amountInUnits = parseUnits(amount, decimals);
  const tx = await contract.transfer(recipient, amountInUnits);
  return tx;
}
